<template>
  <div class="summaryfile">
    <Button
      type="primary"
      :disabled="projectData.endStatusCode == '1' || 
                 projectData.endStatusCode == '2' || 
                 auditDisabled"
      style="margin: 0 10px;"
      @click="initAudit"
    >发起结项审核</Button>
    <Spin
      fix
      v-if="loadingFile"
    >文件加载中..</Spin>
    <div>
      <Card
        class="type-card"
        v-for="fileType in typesAndFiles"
        :key="fileType.fileTypeId"
      >
        <div style="text-align:center;">
          <span>{{fileType.fileTypeName}}</span>
        </div>
        <div style="text-align:center;margin-top:5px;">
          <Button
            type="primary"
            size="small"
            @click="showFiles(fileType)"
          >文件({{fileType.dbfile.length}})</Button>
          <Button
            style="margin-left:15px;"
            type="success"
            size="small"
            @click="fileDragUpload(fileType)"
          >上传</Button>
        </div>
      </Card>
    </div>
    <!-- 文件列表 -->
    <Modal
      v-model="filesVisible"
      :title="filesModalTitle"
      width="800"
    >
      <Table
        :columns="fileColumns"
        :data="filesList"
        height="400"
      ></Table>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="fileUploadVisible"
      :title="uploadModalTitle"
      :mask-closable="false"
      @on-visible-change="uploadVisibleChange"
    >
      <Upload
        type="drag"
        action="/"
        :before-upload="beforeUpload"
      >
        <div style="padding: 20px 0">
          <Icon
            type="ios-cloud-upload"
            size="52"
            style="color: #3399ff"
          ></Icon>
          <p>拖拽上传，暂只支持单选文件</p>
        </div>
      </Upload>
      <div style="margin-top:5px">
        <div
          v-for="uploadFile in uploadedList"
          class="upload-file-item"
        >
          <span>{{uploadFile.fileName}}</span>
          <span
            v-if="uploadFile.success"
            class="upload-success"
          >上传成功</span>
          <span
            v-else
            class="upload-fail"
          >上传失败</span>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="downloadRecordVisible"
      title="下载记录"
      :transfer="true"
    >
      <div style="max-height:400px;overflow:auto">
        <div
          v-for="record in downloadRecord"
          class="record-item"
        >
          <span>{{record.downloadpeople | filterUser}}</span>
          <span class="time">{{record.downloadtime | formatTime}}</span>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal
      title="结项申请"
      v-model="examineVisible"
    >
      <div>
        <div>请确认项目应收款确认无误，结项成功后将无法改变应收款。请仔细核对确认。当前项目应收款为<span style="color:#ed3f14">{{projectData.receivables}}</span></div>
        <span>备注：</span>
        <Input
          style="margin:5px 0;width:300px"
          v-model="rejectReason"
        ></Input>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          @click="passProject"
        >申请结项</Button>
        <Button @click="examineVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'
import axios from 'axios'
import qs from 'qs'
import x2js from "x2js"
import { formatDate } from '@/lib/tool'
import localFile from '@/lib/localFile'

export default {
  props: {
    projectData: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      typesAndFiles: [],
      fileColumns: [
        {
          title: '文件名称',
          key: 'fileName'
        },
        {
          title: '文件类别',
          key: 'fileTypeName',
          width: 130
        },
        {
          title: '上传人员',
          key: 'uploadPerson',
          width: 100
        },
        {
          title: '上传时间',
          width: 100,
          render: (h, params) => {
            // return h('div', new Date(params.row.uploadTime).toLocaleDateString().replace(/\//g, '-'))
            if (params.row.uploadTime) {
              return h('span', params.row.uploadTime.split('.')[0].replace('T', ' '))
            }
            return ''
          }
        },
        {
          title: '操作',
          width: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.downloadFile(params.row)
                  }
                }
              }, '下载'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.deleteFile(params.row)
                  }
                }
              }, '删除'),
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small',
              //   },
              //   on: {
              //     click: () => {
              //       this.showDownloadRecord(params.row)
              //     }
              //   }
              // }, '下载记录'),
            ])
          }
        },
      ],
      loadingFile: false,
      selectFileType: '',
      // downloadRecord: [],
      // downloadRecordVisible: false,
      filesVisible: false,
      filesModalTitle: '文件列表',
      filesList: [],
      fileUploadVisible: false,
      uploadModalTitle: '文件上传',
      uploadedList: [],
      auditDisabled: false,
      rejectReason: '',
      examineVisible: false
    }
  },
  created() {
    this.getFileAndTypes()
  },
  computed: {
    username() {
      return this.$store.state.session.user.name
    }
  },
  methods: {
    // async showDownloadRecord(row) {
    //   this.$Spin.show()
    //   try {
    //     let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/GetDownFileUserList', qs.stringify({
    //       fileID: row.fileGuid
    //     }))
    //     this.$Spin.hide()
    //     this.downloadRecord = rep.data
    //     this.downloadRecordVisible = true
    //   } catch (err) {
    //     console.error(err)
    //   }
    // },
    async getFileAndTypes() {
      this.loadingFile = true
      let rep = await ajax.get(requestUrls.ClFileGather.GetFileGather, {
        params: {
          pid: this.projectData.id
        }
      })
      this.loadingFile = false
      if (rep.data.success) {
        this.typesAndFiles = rep.data.result.items
      }
    },
    async downloadFile(file) {
      // window.open(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/downFile?id=${file.id}&name=${this.username}`)
      // const blobUrl = await localFile.downLoadBlob(file.fileGuid)
      // localFile.currentLoad(blobUrl, file.fileName)
      localFile.directLoadFile(file.fileGuid, file.fileName, file.fileSuffix)
    },
    async deleteFile(file) {
      this.$Modal.confirm({
        title: '删除文件',
        content: `<div>确定删除此文件：${file.fileName}<span style="color:#ed3f14">（此操作不可撤回，请谨慎）</span></div>`,
        onOk: async () => {
          this.$Spin.show()
          try {
            // let formData = new FormData()
            // formData.append('id', file.id)
            // formData.append('name', this.username)
            // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/deleteFile', formData)

            let rep = await ajax.delete(requestUrls.clfile.delFile, { params: { id: file.id } })

            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('删除成功')
              this.filesVisible = false
              this.getFileAndTypes()
            } else {
              this.$Message.error('删除失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('删除失败')
            console.error(err)
          }
        }
      })
    },
    showFiles(files) {
      this.filesModalTitle = files.fileTypeName
      this.filesList = files.dbfile
      this.filesVisible = true
    },
    fileDragUpload(files) {
      this.selectFileType = files
      this.uploadModalTitle = files.fileTypeName
      this.fileUploadVisible = true
    },
    beforeUpload(file) {
      let format = ['jpg', 'jpeg', 'pdf', 'png', 'tif', 'tiff', 'rar', 'zip', 'doc', 'docx', 'xlsx', 'xls', 'JPG', 'JPEG', 'PDF', 'PNG', 'TIF', 'TIFF', 'RAR', 'ZIP', 'DOC', 'DOCX', 'XLSX', 'XLS']
      let type = file.name.split('.')
      type = type[type.length - 1]
      if (format.indexOf(type) === -1) {
        this.$Message.error('不支持的文件类型')
        return false
      }
      this.fileToUpload(file)
      return false
    },
    async fileToUpload(file) {
      // let formData = new FormData()
      // formData.append('fileToUpload', file)
      // formData.append('username', this.username)
      // formData.append('fl', this.selectFileType.fileTypeId)
      // formData.append('fileclass', this.selectFileType.fileTypeName)
      // formData.append('npid', this.projectData.id)
      this.$Spin.show()
      try {
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        // 上传文件
        let fileRep = await localFile.uploadFile(file)

        if (!fileRep) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: this.selectFileType.fileTypeId,
          uploadPerson: this.username,
          fileTypeName: this.selectFileType.fileTypeName
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        
        this.uploadedList.push({
          fileName: file.name,
          success: true
        })
        this.$Message.success('上传成功')
        this.getFileAndTypes()

      } catch (err) {
        console.error(err)
        this.uploadedList.push({
          fileName: file.name,
          success: false
        })
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    uploadVisibleChange(val) {
      if (!val) {
        this.uploadedList = []
      }
    },
    async passProject() {
      // 发起评审
      this.$Spin.show()
      try {
        // let time = new Date().toLocaleDateString()

        let time = formatDate()

        let endStatusName = ''
        const x2Json = new x2js()

        let record = [{}]
        if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
          record = x2Json.xml2js(this.projectData.endStatusName).recordList.record
        }

        record.push({
          applyTime: time,
          rejectTime: time,
          rejectReason: this.rejectReason,
          rejectPerson: this.$store.state.session.user.name,
          status: '结项申请'
        })

        endStatusName = x2Json.js2xml({ recordList: { record: record } })

        let rep = await ajax.put(requestUrls.ClProjectDb.UpdateEndStatus, {
          id: this.projectData.id,
          endStatusCode: '1',
          endStatusName: endStatusName,
          appStartTime: time,
          appPassTime: '',
          appNoPassTime: '',
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('发起成功')
          this.auditDisabled = true
          this.rejectReason = ''
          this.examineVisible = false
        } else {
          this.$Message.error('操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    async initAudit() {
      this.examineVisible = true
      // // 项目应收款确认
      // this.$Modal.confirm({
      //   title: '结项提醒',
      //   content: `<div>请确认项目应收款确认无误，结项成功后将无法改变应收款。请仔细核对确认。当前项目应收款为<span style="color:#ed3f14">${this.projectData.receivables}</span></div>`,
      //   onOk: async () => {
          
      //   }
      // })
    }
  },
  filters: {
    filterUser(val) {
      if (!val) {
        return '***'
      }
      return val
    },
    formatTime(val) {
      if (!val) {
        return ''
      }
      return new Date(parseInt(val.slice(6, 19))).toLocaleString()
    }
  }
}
</script>

<style lang="less">
.type-card {
  width: 180px;
  margin: 5px;
  display: inline-block;
}
.summaryfile {
  margin-top: 5px;
  .ivu-collapse-header:hover {
    background: #eee;
    color: #2b85e4;
  }
}
.record-item {
  padding: 10px 16px;
  position: relative;
  .time {
    position: absolute;
    right: 16px;
  }
}
.record-item + .record-item {
  border-top: 1px solid #ddd;
}
.upload-file-item {
  position: relative;
  padding: 2px 5px;
  .upload-success {
    position: absolute;
    right: 10px;
    color: #19be6b;
  }
  .upload-fail {
    position: absolute;
    right: 10px;
    color: #ed3f14;
  }
}
.upload-file-item + .upload-file-item {
  border-top: 1px solid #ddd;
}
</style>
